// src/pages/TemplatesPage.jsx
import React, { useState, useEffect } from "react";
import { getTemplates, updateTemplates } from "../api/authApi";
import TemplatesPanel from "../components/TemplatesPanel";
import { ABUSE_TEMPLATES } from "../data/AbuseTemplates";
import { useAuth } from "../context/AuthContext";

// Mapping: Display name => column key
const TEMPLATES_MAP = {
	"“One Human, One Trial”": "template_one_human_one_trial",
	"“Fake Viral Growth Prevention”": "template_fake_viral_growth_prevention",
	"“Refund Abuser Flag”": "template_refund_abuser_flag",
	"“Account Farm Shield”": "template_account_farm_shield",
	"“Stealth Scraper Deterrent”": "template_stealth_scraper_deterrent",
	"“Disposable Email Throttle”": "template_disposable_email_throttle",
};
const ALL_TEMPLATE_KEYS = Object.values(TEMPLATES_MAP);

export default function TemplatesPage() {
	const [templates, setTemplates] = useState(Object.fromEntries(ALL_TEMPLATE_KEYS.map((k) => [k, false])));
	const [loading, setLoading] = useState(true);

	const { user, loading: authLoading } = useAuth();

	useEffect(() => {
		if (authLoading || !user) return;
		getTemplates()
			.then((res) => {
				setTemplates({ ...templates, ...res.data });
				setLoading(false);
			})
			.catch(() => setLoading(false));
		// eslint-disable-next-line
	}, [authLoading, user]);

	const allTemplateNames = ABUSE_TEMPLATES.flatMap((g) => g.items.map((item) => item.name));
	const handleToggle = (idx) => {
		const templateName = allTemplateNames[idx];
		const templateKey = TEMPLATES_MAP[templateName];
		const updated = { ...templates, [templateKey]: !templates[templateKey] };
		setTemplates(updated);
		updateTemplates(updated);
	};

	if (loading || authLoading) return <div>Loading…</div>;
	if (!user) return <div>Please log in.</div>;

	// TemplatesPanel expects array of booleans
	const toggles = allTemplateNames.map((name) => templates[TEMPLATES_MAP[name]]);

	return <TemplatesPanel toggles={toggles} onToggle={handleToggle} />;
}
